import script from "./DeviceInfo_ws.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceInfo_ws.vue?vue&type=script&setup=true&lang=js"

import "./DeviceInfo_ws.vue?vue&type=style&index=0&id=87ae2a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ae2a30"]])

export default __exports__